<div
    class="cmps-cdk-my-0dot5"
    *ngFor="let a of group?.areas; let l = last"
>
    <cmps-ca-evaluation-result-focus
        [group]="group"
        [area]="a"
    ></cmps-ca-evaluation-result-focus>
    <div
        class="cmps-cdk-border-b-width-1p cmps-cdk-border-b-solid cmps-cdk-border-b-color-unknown-107 cmps-cdk-h-1px"
        *ngIf="!l"
    ></div>
</div>
